// Maps the short asset-class code from the security-details feed to its display name, so tables show
// "Fixed Income" rather than "FIXI".
export const AssetClassLookup: Record<string, string> = {
  FIXI: 'Fixed Income',
  EQTY: 'Equity',
  COMM: 'Commodity',
}

// Full name when the code is known, otherwise the raw code (never blank for a present value).
export const formatAssetClass = (value: unknown): string => {
  if (typeof value !== 'string' || value === '') return ''
  return AssetClassLookup[value] ?? value
}
